module.exports = __webpack_public_path__ + "img/membership.41ed33ef.svg";